var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-bot-notify"},[_c('div',{staticClass:"group-bot-notify__status",class:`group-bot-notify__status_${_vm.selectedStatus.color}`},[_c('span',{staticClass:"group-bot-notify__text",class:`group-bot-notify__text_${_vm.selectedStatus.color}`},[_vm._v(" "+_vm._s(_vm.selectedStatus.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }